// Import JSON data for different tray types
import zimmerExtraSpaceTestData from '../GrayScale/Zimmer_Extra_Space_Test.json'

interface TrayDataMap {
  [key: string]: {
    dimensions: { width: number; height: number }
    screw: any[]
    plate: any[]
    drill: any[]
    other?: any[]
  }
}

export const useOtherTrayItemsLogic = (trayType: string) => {
  const trayConfig: Record<string, any> = {
    'zimmer extra space test': zimmerExtraSpaceTestData,
  }

  const data = trayConfig[trayType.toLowerCase()]

  if (!data) {
    return {
      otherItems: [],
      hasOtherItems: false,
    }
  }

  const firstKey = Object.keys(data)[0]
  const trayData = data[firstKey] as TrayDataMap[string]
  const otherItems = trayData.other || []

  return {
    otherItems,
    hasOtherItems: otherItems.length > 0,
  }
}
